import { render, staticRenderFns } from "./quantity-stat.app.vue?vue&type=template&id=d804a8b8&"
import script from "./quantity-stat.app.vue?vue&type=script&lang=js&"
export * from "./quantity-stat.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports